
    // Keep all existing FlightOps logic unchanged; only load it when launching the private app.
    if (new URLSearchParams(window.location.search).get('app') === '1') {
      document.documentElement.setAttribute('data-flightops-app', '');
      document.title = 'FlightOps';
      import('/src/main.js');
    }
  